module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [_c('div', {
    staticClass: "modal-backdrop"
  }, [_c('div', {
    staticClass: "modal",
    style: (_vm.style),
    attrs: {
      "role": "dialog",
      "aria-labelledby": "modalTitle",
      "aria-describedby": "modalDescription"
    }
  }, [_c('header', {
    staticClass: "modal-header",
    attrs: {
      "id": "modalTitle"
    }
  }, [_vm._t("header", [_c('h3', [_vm._v(_vm._s(_vm.componentTitle))])]), _vm._v(" "), _c('button', {
    staticClass: "btn-close",
    attrs: {
      "type": "button",
      "aria-label": "Close modal"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n                    x\n                ")])], 2), _vm._v(" "), _c('section', {
    staticClass: "modal-body",
    attrs: {
      "id": "modalDescription"
    }
  }, [_vm._t("body", [_c(_vm.component.type, {
    tag: "component",
    attrs: {
      "config": _vm.component,
      "index": 0,
      "moduleConfig": {},
      "eventBus": _vm.eventBus,
      "extraData": _vm.component.extraData,
      "emitEvents": _vm.component.emitEvents
    }
  })])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8083b00e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/Modal.vue
// module id = 1332
// module chunks = 2